module.exports = __webpack_public_path__ + "img/stor_wrapbg2.b87f70f3.png";